export enum IconType {
  font = 'font',
  svg = 'svg',
  animated = 'animated'
}

export enum IconTag {
  stroked = 'stroked',
  filled = 'filled'
}
